import React from 'react';
import PropTypes from 'prop-types';

const IconSvg = ({ icon, size, ...rest }) => {
  // eslint-disable-next-line import/no-dynamic-require,global-require
  const IconToLoad = require(`./Icons/${icon}`).default;
  return <IconToLoad height={size} width={size} {...rest} />;
};

IconSvg.defaultProps = {
  size: 25,
  fill: 'currentColor',
  stroke: 'currentColor',
};

IconSvg.propTypes = {
  icon: PropTypes.string.isRequired,
  size: PropTypes.number,
  fill: PropTypes.string,
  stroke: PropTypes.string,
};

export default IconSvg;
